import React from "react";
import { AlertCircle, Upload } from "lucide-react";

/**
 * Highly visible "Content Required" placeholder for the Weave team.
 * Used wherever programme-specific source content has not yet been uploaded.
 */
export const ContentRequired = ({ title, description, needed, where, format, onRequest, testid }) => {
  return (
    <div
      className="content-required"
      data-testid={testid || "content-required-placeholder"}
    >
      <div className="flex items-start gap-4">
        <div className="shrink-0 mt-1">
          <AlertCircle size={22} strokeWidth={1.6} className="text-[#f4b847]" />
        </div>
        <div className="flex-1">
          <div className="label-eyebrow text-[#0A0A0A]">Content Required</div>
          {title && (
            <h3 className="font-display text-xl font-semibold tracking-tight text-[#0A0A0A] mt-2">{title}</h3>
          )}
          {description && (
            <p className="mt-2 text-[#525252] text-sm leading-relaxed">{description}</p>
          )}
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs">
            {needed && (
              <div className="border border-[#f4b847]/40 bg-white/60 p-3">
                <div className="label-eyebrow text-[10px]">What's needed</div>
                <div className="mt-1 text-[#0A0A0A]">{needed}</div>
              </div>
            )}
            {where && (
              <div className="border border-[#f4b847]/40 bg-white/60 p-3">
                <div className="label-eyebrow text-[10px]">Where it appears</div>
                <div className="mt-1 text-[#0A0A0A]">{where}</div>
              </div>
            )}
            {format && (
              <div className="border border-[#f4b847]/40 bg-white/60 p-3">
                <div className="label-eyebrow text-[10px]">Acceptable formats</div>
                <div className="mt-1 text-[#0A0A0A]">{format}</div>
              </div>
            )}
          </div>
          {onRequest && (
            <button
              onClick={onRequest}
              data-testid="content-required-request-btn"
              className="mt-5 inline-flex items-center gap-2 border border-[#0A0A0A] px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] hover:bg-[#2596be] hover:text-white hover:border-[#2596be] transition-colors"
            >
              <Upload size={14} strokeWidth={1.6} />
              Log content request
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentRequired;
